import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Row,
  Button,
  Form,
  Nav,
  NavItem,
  NavLink,
  Progress,
  TabContent,
  TabPane,
} from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import React, { useEffect, useRef } from "react";
import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Formik } from "formik";
import Attributes from "./Attributes";
import Offer from "./Offer";
import CustomerDetails from "./CustomerDetails";
import { validationSchemaForCustomer } from "./constants/validationSchema";
import { useDispatch, useSelector } from "react-redux";
import { createCustomer } from "../../slices/customer/create/thunk";
import { updateCustomer } from "../../slices/customer/update/thunk";
import { fetchCustomer } from "../../slices/customer/fetchcustomer/thunk";
import { ToastContainer } from "react-toastify";
import { customerJsonObj } from "./constants/CustomerJsonObj";
import { fetchCountries } from "../../slices/customer/countries/thunk";
import {
  commonIDFunction,
  optionsForCustomerDetails,
} from "./constants/constantFunctions";
import { fetchStates } from "../../slices/customer/states/thunk";
import { customerIdData } from "./constants/constantFunctionsView";
import { fetchCities } from "../../slices/customer/cities/thunk";
import { Loader } from "../Utils/Loader";
import { AttributeNameOptions } from "./constants/constantValues";
import UploadDocument from "./UploadDocument";
import { fetchDocumentsForCustomer } from "../../slices/customer/documentlist/thunk";
import CommonButton from "../Utils/CommonButton";
import {
  customerDialCodeErrorThrow,
  onSubmit,
  onSubmitCustomerFunction,
  registerOrEditCustomer,
} from "./constants/DocumentTableFunctions";
import { isValidPhoneNumber } from "react-phone-number-input";
import { PAGE_TITLES } from "../Common/constants";
import classnames from "classnames";
import { SubscriptionWhileCustomerCreation } from "./SubscriptionWhileCustomerCreation";
import CommonModal from "../Utils/CommonModal";
import {
  bdomDataFunction,
  checkConditions,
  checkMandatoryFields,
  toggleModal,
  toggleTab,
  updateValues,
  validateForm,
} from "./constants/TelcoSubmitFunctions";
import { CommonCustomerDetails } from "./CommonCustomerDetails";
import { getAttributeByType } from "../../slices/attribute/getattributebytype/thunk";
import { viewDoc } from "../../slices/customer/documentview/thunk";
import Stepper from "../Common/Stepper";
import { hasPermission } from "../Utils/UtilityFunctions";

export default function CreateEditCustomer({
  initialAIValues,
  mobileWithDialCode,
}) {
  const [cities, setCities] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState("");
  const [open, setIsOpen] = useState(false);
  const [state, setState] = useState(false);
  const [file, setFile] = useState();
  const [fileName, setFileName] = useState();
  const [enableFormReinitialize, setEnableFormReinitialize] = useState(false);
  const [subscriptionId, setSubscriptionId] = useState([]);
  const [dialCode, setDialCode] = useState("");
  const [onfocus, setOnFocus] = useState(false);
  const [progressbarvalue, setprogressbarvalue] = useState(0);
  const [activeTab, setactiveTab] = useState(1);
  const [passedSteps, setPassedSteps] = useState([1]);
  const [modal, setModal] = useState(false);
  const [valuesForSubmit, setValuesForSubmit] = useState();
  const [confirmed, setConfirmed] = useState();
  const [searchableFormErrorsValues, setSearchableFormErrorValues] = useState();
  const [nonSearchableFormErrorsValues, setNonSearchableFormErrorValues] =
    useState();
  const [callState, setCallState] = useState(false);
  const [callCity, setCallCity] = useState(false);
  const [quantity, setQuantity] = useState(1);
  const [isProfile, setIsProfile] = useState(false);
  const [profilePicture, setProfilePicture] = useState(null);
  const [profileData, setProfileData] = useState(false);
  const [fileSelected, setFileSelected] = useState(false);
  const [editData, setEditData] = useState(null);
  const inputFileRef = useRef(null);
  const [overrideResource, setOverrideResource] = useState({
    0: [{ resourceName: null, value: "" }],
  });

  const operatorConfiguration = useSelector(
    (state) =>
      state?.GetOperatorSpecificConfiguration?.OperatorSpecificConfiguration,
  );
  const prefix =
    operatorConfiguration?.configurations?.Prefixes?.value?.CustomerPrefix
      ?.value ?? "";

  const sequence =
    operatorConfiguration?.configurations?.SequenceHandling?.value
      ?.CustomerSequence?.value ?? "";
  const id = prefix && prefix + "X".repeat(sequence?.length);

  let existingArrayLength = 0;
  let optionCity = [];
  let optionState = [];

  let navigate = useNavigate();
  const roleName = localStorage.getItem("roleName");
  const customerId =
    roleName === "Customer"
      ? localStorage.getItem("customerId")
      : customerIdData();

  const isEdit = location.pathname.includes("update-customer");
  const isCreate = location.pathname.includes("create-customer");
  const isAIPath = window.location.pathname.includes("/chatbot");
  const rawPermissions = useSelector(
    (state) => state.permissions.permissionsMap,
  );

  const permissionsMap = new Map(
    rawPermissions.map(([key, value]) => [key, new Set(value)]),
  );
  const documentPermission = hasPermission(
    permissionsMap,
    "miscellaneous",
    "document",
  );
  const customerPermission = hasPermission(
    permissionsMap,
    "customer",
    "customer",
  );
  const subscriptionPermission = hasPermission(
    permissionsMap,
    "customer",
    "subscription",
  );
  let bdomOptions = bdomDataFunction();
  const dayNumber = new Date().getDate();

  const dispatch = useDispatch();

  const initialFormValues = {
    customerId: "",
    firstName: "",
    lastName: "",
    userName: "",
    email: "",
    password: "",
    mobile: "",
    bdom:
      roleName === "operatorAdmin"
        ? bdomOptions?.find((option) => option.value === dayNumber)
        : bdomOptions[0],
    ...(roleName === "telcoAdmin" && { accountNumber: "" }),
    addressLine1: "",
    addressLine2: "",
    country: "",
    state: "",
    city: "",
    zipCode: "",
    dialCode: "",
    documentType: "",
    documentName: "",
    selectedFile: "",
    subscriptions: [],
    attributeList: [],
    categories: [],
    isSSOUser: false,
  };

  let initialValues = initialFormValues;

  useEffect(() => {
    dispatch(fetchCountries(setLoading, setCallState));
    dispatch(getAttributeByType("customer", setLoading));
  }, [dispatch]);

  const Attributes = useSelector(
    (state) => state.GetAttributeByType.getAttribute,
  );
  const nonSearchableAttributes = useSelector(
    (state) => state.GetAttributeByType.getNonSearchableAttribute,
  );
  const searchableAttributes = useSelector(
    (state) => state.GetAttributeByType.getSearchableAttribute,
  );
  const [searchableValues, setSearchableValues] = useState([]);
  const [nonSearchableValues, setNonSearchableValues] = useState([]);
  const [dynamicGroups, setDynamicGroups] = useState({});

  useEffect(() => {
    if (searchableAttributes?.length > 0) {
      setSearchableValues(
        searchableAttributes.map((attr) => ({
          name: attr.name,
          value: "",
          touched: false,
        })),
      );
    }
  }, [searchableAttributes]);

  useEffect(() => {
    if (nonSearchableAttributes?.length > 0) {
      setNonSearchableValues(
        nonSearchableAttributes.map((attr) => ({ name: attr.name, value: "" })),
      );
    }
  }, [nonSearchableAttributes]);

  const countries = useSelector((state) => state.Countries.countries);
  let countryID = commonIDFunction(countries?.countries);
  const options = optionsForCustomerDetails(countryID);

  useEffect(() => {
    if (isEdit) {
      dispatch(
        fetchCustomer(
          setLoading,
          customerId,
          initialValues,
          customerPermission,
          setSubscriptionId,
          isEdit,
          setDialCode,
          setEditData,
        ),
      );
      dispatch(fetchDocumentsForCustomer(setLoading, customerId));
    }
  }, [dispatch]);

  const fetchCustomerData = useSelector(
    (state) => state.FetchCustomer.fetchCustomer,
  );

  const [listAttributesForBinding, setListAttributesForBinding] = useState([]);
  useEffect(() => {
    if (isEdit && fetchCustomerData?.customerInfo?.attributeList) {
      const formatted = fetchCustomerData.customerInfo.attributeList
        .filter((item) => Array.isArray(item.value))
        .map((item) => ({
          attributeName: item.name,
          attributeValue: item.value.map((v) => v.value),
        }));

      setListAttributesForBinding(formatted);
    } else {
      setListAttributesForBinding([]);
    }
  }, [isEdit, fetchCustomerData]);

  const fetchDocumentData = useSelector(
    (state) => state.DocumentList.documentList,
  );
  const [attributeNamesAndValues, setAttributeNamesAndValues] = useState([]);

  useEffect(() => {
    if (fetchCustomerData?.customerInfo?.attributeList) {
      const attributes = fetchCustomerData.customerInfo.attributeList.map(
        (attr) => ({
          name: attr.name,
          value: attr.value,
        }),
      );
      setAttributeNamesAndValues(attributes);
    }
  }, [fetchCustomerData]);

  useEffect(() => {
    if (isEdit) {
      const updatedSearchableValues = updateValues(
        searchableValues,
        attributeNamesAndValues,
        searchableAttributes,
      );
      const updatedNonSearchableValues = updateValues(
        nonSearchableValues,
        attributeNamesAndValues,
        nonSearchableAttributes,
      );
      setSearchableValues(updatedSearchableValues);
      setNonSearchableValues(updatedNonSearchableValues);
    }
  }, [attributeNamesAndValues, isEdit]);

  useEffect(() => {
    if (
      isEdit &&
      fetchCustomerData &&
      fetchCustomerData?.customerInfo?.userName
    ) {
      let partnerOrCustomer = "Customer";
      dispatch(
        viewDoc(
          setLoading,
          customerId,
          "logo",
          partnerOrCustomer,
          setProfileData,
        ),
      );
    }
  }, [dispatch, isEdit, fetchCustomerData]);

  let base64ImageData = [];
  let profile = useSelector((state) => state.ViewDocument.documentView);
  const [update, setUpdate] = useState(!!profile);
  base64ImageData = profile?.filePath;
  const documentName = profile?.documentName;

  useEffect(() => {
    if (isEdit && base64ImageData) {
      setProfilePicture(base64ImageData);
    }
    if (!profileData && isEdit) {
      setProfilePicture(null);
    }
  }, [isEdit, base64ImageData, profileData]);

  let subscriptionsLength = 0;
  if (isEdit) {
    if ("subscriptionList" in fetchCustomerData) {
      subscriptionsLength = fetchCustomerData?.subscriptionList?.length;
    }
  }

  useEffect(() => {
    if (callState) {
      dispatch(fetchStates(selectedCountry, setCallCity));
    }
  }, [dispatch, isEdit, selectedCountry]);

  let statesData = useSelector((state) => state.States.states);

  let stateID = commonIDFunction(statesData?.states);
  optionState = optionsForCustomerDetails(stateID);

  useEffect(() => {
    if (callCity) {
      dispatch(fetchCities(selectedCountry, selectedState));
    }
  }, [dispatch, selectedCountry, selectedState]);

  let cityData = useSelector((state) => state.Cities.cities);

  let cityID = commonIDFunction(cityData?.cities);
  optionCity = optionsForCustomerDetails(cityID);

  useEffect(() => {
    if (isCreate) {
      setEnableFormReinitialize(true);
      setSearchableValues(
        searchableValues.map((field) => ({
          ...field,
          value:
            typeof field.value === "object" && field.value !== null
              ? { label: "", value: "" }
              : "",
        })),
      );
      setNonSearchableValues(
        nonSearchableValues.map((field) => ({
          ...field,
          value:
            typeof field.value === "object" && field.value !== null
              ? { label: "", value: "" }
              : "",
        })),
      );
    }
  }, [isCreate]);

  const conditionsSearchableResult = checkConditions(
    searchableValues,
    searchableAttributes,
  );
  const conditionsNonSearchableResult = checkConditions(
    nonSearchableValues,
    nonSearchableAttributes,
  );
  const allFieldsTrue =
    Object.values(conditionsSearchableResult).every(
      (field) => field === true,
    ) &&
    Object.values(conditionsNonSearchableResult).every(
      (field) => field === true,
    );
  const commonTrueOrFalse = allFieldsTrue ? true : false;

  const operatorId = localStorage.getItem("operatorId");

  const isEIPEnabled =
    operatorConfiguration?.configurations?.EIP?.value?.Enabled?.value ?? false;

  useEffect(() => {
    if (isEdit) {
      setTitle(
        isEIPEnabled
          ? PAGE_TITLES.CUSTOMER_LIST_EIP
          : PAGE_TITLES.CUSTOMER_LIST,
      );
    } else {
      setTitle(
        isEIPEnabled
          ? PAGE_TITLES.CUSTOMER_LIST_EIP
          : PAGE_TITLES.CUSTOMER_LIST,
      );
    }
  }, [isEdit, operatorId]);

  const customerListTitle = isEIPEnabled
    ? isEdit
      ? PAGE_TITLES.EDIT_CUSTOMER_EIP
      : PAGE_TITLES.ADD_CUSTOMER_EIP
    : isEdit
      ? PAGE_TITLES.EDIT_CUSTOMER
      : PAGE_TITLES.ADD_CUSTOMER;

  const moduleTitle = isEIPEnabled
    ? PAGE_TITLES.CUSTOMER_LIST_EIP
    : PAGE_TITLES.CUSTOMER_LIST;

  return (
    <div>
      <Formik
        validationSchema={validationSchemaForCustomer(
          customerPermission,
          state,
          id,
          isEIPEnabled,
        )}
        initialValues={isAIPath ? initialAIValues : initialValues}
        enableReinitialize={enableFormReinitialize}
        onSubmit={(values) => {
          if (
            (roleName !== "telcoAdmin" &&
              roleName !== "telcoOperationUser" &&
              roleName !== "telcoBusinessUser") ||
            ((roleName === "telcoAdmin" ||
              roleName === "telcoOperationUser" ||
              roleName === "telcoBusinessUser") &&
              isEdit &&
              commonTrueOrFalse) ||
            isAIPath
          ) {
            let isAIDialCode = isAIPath ? mobileWithDialCode : dialCode;
            onSubmitCustomerFunction({
              values,
              isEdit,
              subscriptionsLength,
              setLoading,
              dispatch,
              customerId,
              navigate,
              dialCode: isAIDialCode,
              roleName,
              searchableValues,
              nonSearchableValues,
              quantity,
              profilePicture,
              fileSelected,
              setFileSelected,
              update,
              setUpdate,
              profile,
              isProfile,
              overrideResource,
              setOverrideResource,
              dynamicGroups,
            });
          } else {
            setValuesForSubmit(values);
            if (!confirmed && commonTrueOrFalse) {
              toggleModal(setModal, modal);
            } else if (commonTrueOrFalse) {
              toggleTab(
                2,
                100,
                activeTab,
                passedSteps,
                setactiveTab,
                setPassedSteps,
                setprogressbarvalue,
              );
            }
          }
        }}
      >
        {({
          handleChange,
          handleBlur,
          handleSubmit,
          errors,
          touched,
          values,
          setFieldValue,
          setFieldTouched,
          setTouched,
          resetForm,
          setFieldError,
        }) => (
          <Form id="csms" className="needs-validation" onSubmit={handleSubmit}>
            <div>
              <ToastContainer position="top-center" />
              <div className={!isAIPath ? "page-content bg-white" : "pb-5"}>
                {(roleName !== "telcoAdmin" &&
                  roleName !== "telcoOperationUser" &&
                  roleName !== "telcoBusinessUser") ||
                ((roleName === "telcoAdmin" ||
                  roleName === "telcoOperationUser" ||
                  roleName === "telcoBusinessUser") &&
                  isEdit) ||
                isAIPath ? (
                  <CommonCustomerDetails
                    setFieldError={setFieldError}
                    isAIPath={isAIPath}
                    searchableFormErrorsValues={searchableFormErrorsValues}
                    setSearchableFormErrorValues={setSearchableFormErrorValues}
                    nonSearchableFormErrorsValues={
                      nonSearchableFormErrorsValues
                    }
                    setNonSearchableFormErrorValues={
                      setNonSearchableFormErrorValues
                    }
                    searchableAttributes={searchableAttributes}
                    nonSearchableAttributes={nonSearchableAttributes}
                    setNonSearchableValues={setNonSearchableValues}
                    searchableValues={searchableValues}
                    nonSearchableValues={nonSearchableValues}
                    setSearchableValues={setSearchableValues}
                    identifiers={searchableAttributes}
                    Attributes={nonSearchableAttributes}
                    title={title}
                    customerPermission={customerPermission}
                    values={values}
                    touched={touched}
                    bdomOptions={bdomOptions}
                    errors={errors}
                    dialCode={isAIPath ? mobileWithDialCode : dialCode}
                    setDialCode={setDialCode}
                    setFieldValue={setFieldValue}
                    onfocus={onfocus}
                    setOnFocus={setOnFocus}
                    setFieldTouched={setFieldTouched}
                    initialValues={initialValues}
                    handleBlur={handleBlur}
                    handleChange={handleChange}
                    options={options}
                    optionCity={optionCity}
                    optionState={optionState}
                    setSelectedCountry={setSelectedCountry}
                    setSelectedState={setSelectedState}
                    setSelectedCity={setSelectedCity}
                    cityData={cityData}
                    setCities={setCities}
                    isEdit={isEdit}
                    documentPermission={documentPermission}
                    fetchDocumentData={fetchDocumentData}
                    open={open}
                    setIsOpen={setIsOpen}
                    file={file}
                    setFile={setFile}
                    fileName={fileName}
                    setFileName={setFileName}
                    setState={setState}
                    setTouched={setTouched}
                    roleName={roleName}
                    navigate={navigate}
                    isProfile={isProfile}
                    setIsProfile={setIsProfile}
                    profilePicture={profilePicture}
                    setProfilePicture={setProfilePicture}
                    inputFileRef={inputFileRef}
                    dispatch={dispatch}
                    setLoading={setLoading}
                    customerId={fetchCustomerData?.customerInfo?.customerId}
                    setUpdate={setUpdate}
                    setFileSelected={setFileSelected}
                    documentName={documentName}
                    dynamicGroups={dynamicGroups}
                    setDynamicGroups={setDynamicGroups}
                    listAttributesForBinding={listAttributesForBinding}
                  />
                ) : (
                  <>
                    <BreadCrumb
                      title={customerListTitle}
                      pageTitle={customerListTitle}
                      moduleTitle={moduleTitle}
                    />
                    <h5 className="rv-page-title p-0 ps-2">
                      {customerListTitle}
                    </h5>
                    <Stepper
                      activeTab={activeTab}
                      step1Desc={`Create ${
                        isEIPEnabled ? "Device" : "Customer"
                      }`}
                      onClickStep1={() => {
                        toggleTab(
                          1,
                          0,
                          activeTab,
                          passedSteps,
                          setactiveTab,
                          setPassedSteps,
                          setprogressbarvalue,
                        );
                      }}
                      step2Desc={`Subscribe for ${
                        isEIPEnabled ? "Device" : "Customer"
                      }`}
                      onClickStep2={() => {
                        if (!errors && commonTrueOrFalse) {
                          toggleTab(
                            2,
                            100,
                            activeTab,
                            passedSteps,
                            setactiveTab,
                            setPassedSteps,
                            setprogressbarvalue,
                          );
                        } else if (commonTrueOrFalse) {
                          handleSubmit();
                          const searchableFormErrors = validateForm(
                            searchableAttributes,
                            searchableValues,
                          );
                          setSearchableFormErrorValues(searchableFormErrors);
                          const nonSearchableFormErrors = validateForm(
                            nonSearchableAttributes,
                            nonSearchableValues,
                          );
                          setNonSearchableFormErrorValues(
                            nonSearchableFormErrors,
                          );
                          customerDialCodeErrorThrow(
                            onfocus,
                            dialCode,
                            setOnFocus,
                          );
                        }
                      }}
                    />
                    <TabContent activeTab={activeTab}>
                      <TabPane tabId={1}>
                        <CommonCustomerDetails
                          setFieldError={setFieldError}
                          commonTrueOrFalse={commonTrueOrFalse}
                          searchableFormErrorsValues={
                            searchableFormErrorsValues
                          }
                          setSearchableFormErrorValues={
                            setSearchableFormErrorValues
                          }
                          nonSearchableFormErrorsValues={
                            nonSearchableFormErrorsValues
                          }
                          setNonSearchableFormErrorValues={
                            setNonSearchableFormErrorValues
                          }
                          searchableAttributes={searchableAttributes}
                          nonSearchableAttributes={nonSearchableAttributes}
                          setNonSearchableValues={setNonSearchableValues}
                          searchableValues={searchableValues}
                          nonSearchableValues={nonSearchableValues}
                          setSearchableValues={setSearchableValues}
                          identifiers={searchableAttributes}
                          Attributes={nonSearchableAttributes}
                          title={title}
                          customerPermission={customerPermission}
                          values={values}
                          touched={touched}
                          bdomOptions={bdomOptions}
                          errors={errors}
                          dialCode={dialCode}
                          setDialCode={setDialCode}
                          setFieldValue={setFieldValue}
                          onfocus={onfocus}
                          setOnFocus={setOnFocus}
                          setFieldTouched={setFieldTouched}
                          initialValues={initialValues}
                          handleBlur={handleBlur}
                          handleChange={handleChange}
                          options={options}
                          optionCity={optionCity}
                          optionState={optionState}
                          setSelectedCountry={setSelectedCountry}
                          setSelectedState={setSelectedState}
                          setSelectedCity={setSelectedCity}
                          cityData={cityData}
                          setCities={setCities}
                          isEdit={isEdit}
                          documentPermission={documentPermission}
                          fetchDocumentData={fetchDocumentData}
                          open={open}
                          setIsOpen={setIsOpen}
                          file={file}
                          setFile={setFile}
                          fileName={fileName}
                          setFileName={setFileName}
                          setState={setState}
                          setTouched={setTouched}
                          roleName={roleName}
                          navigate={navigate}
                          isProfile={isProfile}
                          setIsProfile={setIsProfile}
                          profilePicture={profilePicture}
                          setProfilePicture={setProfilePicture}
                          inputFileRef={inputFileRef}
                          dispatch={dispatch}
                          setLoading={setLoading}
                          customerId={
                            fetchCustomerData?.customerInfo?.customerId
                          }
                          setUpdate={setUpdate}
                          setFileSelected={setFileSelected}
                          documentName={documentName}
                          dynamicGroups={dynamicGroups}
                          setDynamicGroups={setDynamicGroups}
                          listAttributesForBinding={listAttributesForBinding}
                        />
                      </TabPane>
                      <TabPane tabId={2}>
                        <SubscriptionWhileCustomerCreation
                          searchableValues={searchableValues}
                          nonSearchableValues={nonSearchableValues}
                          activeTab={activeTab}
                          passedSteps={passedSteps}
                          setactiveTab={setactiveTab}
                          setPassedSteps={setPassedSteps}
                          setprogressbarvalue={setprogressbarvalue}
                          roleName={roleName}
                          values={values}
                          isEdit={isEdit}
                          subscriptionsLength={subscriptionsLength}
                          setParentLoading={setLoading}
                          dispatch={dispatch}
                          customerId={customerId}
                          dialCode={dialCode}
                          customerPermission={customerPermission}
                          navigate={navigate}
                          setQuantity={setQuantity}
                          quantity={quantity}
                          profilePicture={profilePicture}
                          fileSelected={fileSelected}
                          setFileSelected={setFileSelected}
                          update={update}
                          setUpdate={setUpdate}
                          profile={profile}
                          isProfile={isProfile}
                          editData={editData}
                          overrideResource={overrideResource}
                          setOverrideResource={setOverrideResource}
                          errors={errors}
                          touched={touched}
                          handleBlur={handleBlur}
                          setFieldValue={setFieldValue}
                        />
                      </TabPane>
                    </TabContent>{" "}
                  </>
                )}
              </div>
            </div>
          </Form>
        )}
      </Formik>
      {loading && <Loader />}
      <div>
        {!confirmed && (
          <CommonModal
            messageForPopUp={"Do you want to create a subscription?"}
            closeButtonAction={() => {
              toggleModal(setModal, modal);
              onSubmitCustomerFunction({
                values: valuesForSubmit,
                isEdit,
                subscriptionsLength,
                setLoading,
                dispatch,
                customerId,
                navigate,
                dialCode,
                roleName,
                searchableValues,
                nonSearchableValues,
                quantity,
                profilePicture,
                fileSelected,
                setFileSelected,
                update,
                setUpdate,
                profile,
                isProfile,
                overrideResource,
                setOverrideResource,
                editData,
                dynamicGroups,
            });
            }}
            closeButtonText={"No, Create Customer"}
            fromCustomer={"Customer"}
            toggle={() => {
              toggleModal(setModal, modal);
            }}
            open={modal}
            buttonText={"Yes, Proceed"}
            modalAction={() => {
              toggleTab(
                2,
                100,
                activeTab,
                passedSteps,
                setactiveTab,
                setPassedSteps,
                setprogressbarvalue,
              );
              toggleModal(setModal, modal);
              setConfirmed(true);
            }}
          />
        )}
      </div>
    </div>
  );
}
